import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M9 12.879V15h2.121L20 6.121A1.5 1.5 0 1017.879 4L9 12.879z" }),
    React.createElement("path", { d: "M6 6h6V4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-2v6H6V6z" })));
export default createSvgIcon(iconPath, "Edit");
//# sourceMappingURL=EditIcon.js.map